export default "__VITE_ASSET__DEQLe9TJ__"